export const  CREATE_SLOTS_REQUEST='tutorReducer/CREATE_SLOTS_REQUEST';
export const  CREATE_SLOTS_SUCCESS='tutorReducer/CREATE_SLOTS_SUCCESS';
export const  CREATE_SLOTS_FAILED='tutorReducer/CREATE_SLOTS_FAILED';